/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseReferenceState } from './courseReferenceState';

/**
 * Lightweight reference to a course, used to avoid recursion
when embedding courses inside modules.
 */
export interface CourseReference {
  id: string;
  title: string;
  state?: CourseReferenceState;
}
